          document.addEventListener('DOMContentLoaded', function() {
    const accordionItems = document.querySelectorAll('.accordion button');

    function toggleAccordion() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Collapse all
        accordionItems.forEach(item => {
            item.setAttribute('aria-expanded', 'false');
            item.nextElementSibling.style.display = 'none'; // Use display for collapsing
        });

        // If not already expanded, expand this one
        if (!isExpanded) {
            this.setAttribute('aria-expanded', 'true');
            this.nextElementSibling.style.display = 'block'; // Show the content
        }
    }

    accordionItems.forEach(item => item.addEventListener('click', toggleAccordion));
});
 // featured item slider
      // Function to initialize the carousel for a given selector
      function initializeCarousel(carouselSelector, prevButtonSelector, nextButtonSelector) {
        const carousel = document.querySelector(carouselSelector);
        const prevButton = document.querySelector(prevButtonSelector);
        const nextButton = document.querySelector(nextButtonSelector);

        let currentIndex = 0;
        const totalItems = document.querySelectorAll(`${carouselSelector} .custom-carousel-item, ${carouselSelector} .customrw-carousel-item`).length;

        function updateCarousel() {
          const screenWidth = window.innerWidth;
          const visibleItems = screenWidth >= 768 ? 5 : 1; // Show 5 on desktop, 2 on mobile
          const itemWidth = document.querySelector(`${carouselSelector} .custom-carousel-item, ${carouselSelector} .customrw-carousel-item`).offsetWidth;
          const margin = screenWidth >= 768 ? 10 : 5; // Margin between items
          const maxIndex = totalItems - visibleItems;

          if (currentIndex < 0) {
            currentIndex = 0;
          } else if (currentIndex > maxIndex) {
            currentIndex = maxIndex;
          }

          const offset = -(itemWidth + margin) * currentIndex; // Adjust offset including margin
          carousel.style.transform = `translateX(${offset}px)`;
        }

        nextButton.addEventListener('click', () => {
          currentIndex++;
          updateCarousel();
        });

        prevButton.addEventListener('click', () => {
          currentIndex--;
          updateCarousel();
        });

        window.addEventListener('resize', updateCarousel);
        updateCarousel();
      }

      // Initialize both carousels
      initializeCarousel('.custom-carousel', '#custom-prev', '#custom-next');
      initializeCarousel('.customrw-carousel', '#customrw-prev', '#customrw-next');


 // JS to handle tab switching on image or link click
    ['prof', 'entpr', 'studs', 'freelanc', 'hwife'].forEach(id => {
      document.getElementById(`img-${id}`).addEventListener('click', () => document.getElementById(`tab${id === 'prof' ? 1 : id === 'entpr' ? 2 : id === 'studs' ? 3 : id === 'freelanc' ? 4 : 5}`).click());
      document.getElementById(`link-${id}`).addEventListener('click', () => document.getElementById(`tab${id === 'prof' ? 1 : id === 'entpr' ? 2 : id === 'studs' ? 3 : id === 'freelanc' ? 4 : 5}`).click());
    });

// Array of names for the notification
const names = ["Rajesh Verma ,", "Priya Kapoor ,", "Amit Sharma ,", "Sakshi Jain ,", "Ravi Mehta ,", "Nisha Reddy ,", "Anil Desai ,", "Sunita Gupta ,", "Kunal Patel ,", "Pooja Singh ,", "Mohit Sinha ,"];

// Function to update the notification text
function updateNotification() {
    const name = names.shift(); // Remove the first name from the array
    document.getElementById("name").textContent = name; // Set the name
    names.push(name); // Add the name to the end of the array to loop it
}

// Update every 1 second
setInterval(updateNotification, 1000);



   